import React from 'react'

import {
    PaginationLeftContainer,
    PaginationRightContainer,
    PaginationImage,
} from './styles'

const PrevArrow = props => {
    const { onClick, className } = props

    console.log('prevProps :- ', props)

    return (
        <PaginationLeftContainer
            onClick={onClick}
            visible={className.includes('slick-disabled')}
        >
            <PaginationImage src="/assets/arrow_left.svg" alt="prev-button" />
        </PaginationLeftContainer>
    )
}

const NextArrow = props => {
    const { onClick, className } = props

    console.log('nextProps :- ', props)

    return (
        <PaginationRightContainer
            onClick={onClick}
            visible={className.includes('slick-disabled')}
        >
            <PaginationImage src="/assets/arrow_right.svg" alt="next-button" />
        </PaginationRightContainer>
    )
}

export { PrevArrow, NextArrow }
